import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import { useDispatch } from 'react-redux';
import { DEFAULT_GRAPH_EDIT_CONFIG } from '../../../custom-report.serivce';
import isEmpty from 'lodash/isEmpty';
import { toggleModal } from 'state/callers';
import { reportedMetricsModalOptions } from 'modals/modal-options-factory';
import EditDefaults from '../EditDefaults';
import { LBButton } from '@linearb/buzz';

const ReportedEditSection = ({
  isHover,
  isEditable,
  editConfig = DEFAULT_GRAPH_EDIT_CONFIG,
  onColorChange,
  onRemove,
  goToSettings,
  widget,
  onChange,
  isEmptyStateMetric
}) => {
  const dispatch = useDispatch();

  const { id: widgetId, color } = widget;

  if (!isEditable && isEmpty(goToSettings)) {
    return null;
  }

  const SettingsIcon = () => (
    <LBButton
      size='icon'
      variant='outline'
      onClick={() =>
        toggleModal(
          reportedMetricsModalOptions({
            widget,
            onChange
          })
        )(dispatch)
      }
      data-testid={goToSettings.dataTestid}
      data-cy={`pinned-settings-icon-${widgetId}`}
    >
      <Icon size='normal' name='settings' alpha={0.7} />
    </LBButton>
  );

  const editDefaultProps = {
    isEditable,
    editConfig,
    isHover,
    color,
    onColorChange,
    onRemove
  };

  return (
    <Flex data-testid='graph-box-edit-section' items='center'>
      {!isEmptyStateMetric && <EditDefaults {...editDefaultProps} />}
      <div>
        <SettingsIcon />
      </div>
    </Flex>
  );
};

export default ReportedEditSection;
